import { render, staticRenderFns } from "./SuccessFeedback.vue?vue&type=template&id=633fc2d9&scoped=true&"
import script from "./SuccessFeedback.vue?vue&type=script&lang=js&"
export * from "./SuccessFeedback.vue?vue&type=script&lang=js&"
import style0 from "./SuccessFeedback.vue?vue&type=style&index=0&id=633fc2d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633fc2d9",
  null
  
)

export default component.exports